// crewbit-admin/src/hooks/useClientDefaults.ts
//
// Tier 2 Phase D §WorldClass.1 — per-client overrides substrate.
// Admin paired hook for get_client_defaults RPC (Migration 275).
// Mirrors crewbit-mobile/hooks/useClientDefaults.ts.
//
// Read-only RPC; no event emit. Invoice authoring UI consumes resolved + sources
// + reasoning to pre-fill form fields with override-pill provenance per §0.13.

import { useCallback } from 'react';
import { callMoneyRpc, type MoneyRpcResult } from '../lib/moneyRpc';
import type {
  ClientDefaultsResolved,
  ClientDefaultsSources,
  ClientDefaultsReasoning,
} from '../types/clientDefaults';

export interface ClientDefaultsArgs {
  clientId: string;
}

export type ClientDefaultsHookResult = MoneyRpcResult<{
  client_id: string;
  resolved: ClientDefaultsResolved;
  sources: ClientDefaultsSources;
  reasoning: ClientDefaultsReasoning;
}>;

export function useClientDefaults() {
  return useCallback(
    async (args: ClientDefaultsArgs): Promise<ClientDefaultsHookResult> => {
      return callMoneyRpc<{
        client_id: string;
        resolved: ClientDefaultsResolved;
        sources: ClientDefaultsSources;
        reasoning: ClientDefaultsReasoning;
      }>('get_client_defaults', { p_client_id: args.clientId });
    },
    [],
  );
}
